import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { launchGapGame } from "../services/gap.service";
import { FeedbackModal as ErrorModal } from "../../../components/ui/modals/FeedbackModal";
import { localStorageService } from "../../../services";
import userDeviceStore from "../../../store/device.store";

export function LaunchGap() {
  const navigate = useNavigate();
  const accessModeSource = userDeviceStore((state) => state.accessModeSource);

  const [loading, setLoading] = useState(true);
  const [gameLaunchUrl, setGameLaunchUrl] = useState<string | null>(null);


  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        if (localStorageService.getItem("isUserLoggedIn") === true) {
          const url = await launchGapGame("SAP", "550000", accessModeSource.sourceType);
          if (mounted) {
            setGameLaunchUrl(url);
          }
        }
        else {
          navigate("/login");
        }
      } catch {
        navigate("/");
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    init();

    return () => {
      mounted = false;
      setGameLaunchUrl(null);
    };
  }, [navigate]);

  return (
    <div>
      <div
        id="sportsindiaiframe"
        className="w-full flex
        h-[calc(100vh-64px)]
        lg:h-[calc(100vh-64px)]
        max-lg:h-[calc(100vh-64px-80px)] z-[999]"
      >
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-black z-10">
            {/* <img src="" alt="Sky 365" />*/} Loading...
          </div>
        )}

        {!loading && gameLaunchUrl && (
          <iframe
            src={gameLaunchUrl}
            title="Bharat Sportsbook"
            className="w-full h-full border-0"
          />
        )}
      </div>

      <ErrorModal
        id="bharat-sportsbook-error-modal"
        isOpen={true}
        title="Failed!"
        className="hidden"
        description="Unable to launch Bharat Sportsbook at the moment. Please try again later."
        onClose={() => {
          navigate("/");
        }}
        blurColor="bg-[#FFD4D4]"
      ></ErrorModal>
    </div>
  );
}
